// extracted by mini-css-extract-plugin
export default {"heroImage":"AtTwoHero_heroImage__YcbfT","heroHeader":"AtTwoHero_heroHeader__ZdoRa","heroTitle":"AtTwoHero_heroTitle__6F6rh","heroParagraph":"AtTwoHero_heroParagraph__cdMQg"};